<template>
  <auth-layout pageClass="login-page">
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col lg="4" md="6" sm="8">
        <form v-on:submit.prevent="onSubmit">
          <fade-render-transition>
            <card>
              <div slot="header" class="text-center">
                <h3 class="card-title text-center">Reset Password</h3>
                <small class="text-center">Please create your New Password</small>
              </div>
              <div>
                <fg-input label="Password"
                          placeholder="Enter password"
                          type="password"
                          autofocus
                          name="password"
                          ref="password"
                          v-model="model.password"
                          v-bind:class="errors.has('password') ? 'is-invalid':''" v-validate="'required'">

                </fg-input>
                <fg-input label="Password Confirmation"
                          placeholder="Password confirmation"
                          type="password"
                          autofocus
                          name="passwordConfirmation"
                          v-model="model.passwordConfirmation"
                          v-bind:class="errors.has('passwordConfirmation') ? 'is-invalid':''" v-validate="'required|confirmed:password'">

                </fg-input>
              </div>
              <div class="text-center">
                <b-button variant="success" type="submit" class="btn-fill btn-round btn-wd "><font-awesome-icon v-if="isLoading" icon="spinner" spin /> Reset</b-button>
                <br>
                <div class="forgot">
                  <router-link to="/login" class="card-category">
                    Back To Log In
                  </router-link>
                </div>
              </div>
            </card>
          </fade-render-transition>
        </form>
      </b-col>
    </b-row>
  </auth-layout>
</template>
<script>
  import { FadeRenderTransition } from '@/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      FadeRenderTransition,
      AuthLayout
    },
    data () {
      return {
        errorMsg: null,
        isLoading: false,
        model: {
          email: '',
          passwordConfirmation: ''
        }
      }
    },
    methods: {
      onSubmit () {
        if (this.isLoading) {
          return false
        }
        this.$validator.validateAll().then(res => {
          this.$notifications.clear()
          if (res) {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'resetpassword/newpassword', {
              resetPasswordKey: this.$route.params.uuid,
              newPassword: this.model.password,
              confirmNewPassword: this.model.passwordConfirmation
            }).then(response => {
              this.isLoading = false
              this.model.newPassword = null
              this.model.confirmNewPassword = null
              this.$validator.reset()
              this.$store.dispatch('notification/success', 'Password has been changed.')
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      }
    },
    destroyed () {
      this.$notifications.clear()
    }
  }
</script>

<style scoped>
  button svg {
    float: left;
    margin-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Auth/ResetPassword.vue